import type { EmptyReturnBoardItem, EmptyReturnBoardListQuery, EmptyReturnInput, Page } from '@chukua/common';
import { api } from '../../shared/shared.api';
import { toListParams } from '../../shared/policies/list-params';

export function listDeadlines(query: EmptyReturnBoardListQuery): Promise<Page<EmptyReturnBoardItem>> {
  return api<Page<EmptyReturnBoardItem>>(`/deadlines?${toListParams(query)}`);
}

export async function markEmptyReturned(jobId: string, containerId: string, input: EmptyReturnInput): Promise<void> {
  await api<unknown>(`/jobs/${jobId}/containers/${containerId}/empty-return`, { method: 'POST', body: JSON.stringify(input) });
}
